module.exports = __webpack_public_path__ + "static/media/card3.e6b1ce80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/card3.jpg
// module id = 876
// module chunks = 0